import { Box, VStack, Heading, Text, Button, HStack, Badge, Image } from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

function TeacherCard({ teacher }) {
  const navigate = useNavigate();

  const formatRating = (rating) => {
    return rating.toFixed(1);
  };

  const formatPrice = (rate, currency) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(rate);
  };

  const getSlug = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={6}
      bg="white"
      _hover={{ shadow: 'md', transform: 'translateY(-2px)', transition: 'all 0.2s' }}
    >
      <VStack spacing={4} align="stretch" height="100%">
        <HStack spacing={4}>
          <Image
            src={teacher.headshot_url || 'https://via.placeholder.com/100'}
            alt={teacher.full_name}
            borderRadius="full"
            boxSize="100px"
            objectFit="cover"
          />
          <VStack align="start" spacing={1} flex={1}>
            <Heading size="md" color="teal.800">{teacher.full_name}</Heading>
            <Badge colorScheme="teal">{teacher.specialty}</Badge>
          </VStack>
        </HStack>
        
        <Box height="24px">
          {teacher.review_count > 0 ? (
            <HStack spacing={2}>
              <StarIcon color="yellow.400" />
              <Text fontWeight="medium">{formatRating(teacher.rating)}/5.0</Text>
              <Text color="gray.500">({teacher.review_count} reviews)</Text>
            </HStack>
          ) : (
            <Text color="gray.400" fontSize="sm">No reviews yet</Text>
          )}
        </Box>
        
        <Text fontSize="lg" fontWeight="bold" color="teal.600">
          {formatPrice(teacher.rate, teacher.currency)}/hour
        </Text>
        
        <Text color="gray.600" noOfLines={2} flex={1}>
          {teacher.bio}
        </Text>
        
        <Button 
          colorScheme="teal" 
          size="md" 
          onClick={() => navigate(`/teachers/${getSlug(teacher.full_name)}`)}
        >
          View Profile
        </Button>
      </VStack>
    </Box>
  );
}

export default TeacherCard; 